import client from '@/services/';

const state = () => ({
    all: [],
    one: {}
});

const getters = {
    all: state => state.all,
    one: state => state.one
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
};

const actions = {
    async getAll({ commit }, params = {}) {
        const { page = 0, size = 10, sort = ''} = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
        }).toString();
        let data = await client.get(`logs/all?${queryParams}`);
        commit("SET_ALL", data.data)
        return data.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
